export const fengObj = {
    // flag_specialList_c: "产品输出标识",
    sl_id_court_bad: "通过id查询法院失信人",
    sl_id_court_executed: "通过id查询法院被执行人",
    sl_id_bank_bad: "通过id查询银行(含信用卡)中风险",
    sl_id_bank_overdue: "通过id查询银行(含信用卡)一般风险",
    sl_id_bank_lost: "通过id查询银行(含信用卡)高风险",
    sl_id_nbank_bad: "通过id查询非银(含全部非银类型)中风险",
    sl_id_nbank_overdue: "通过id查询非银(含全部非银类型)一般风险",
    sl_id_nbank_lost: "通过id查询非银(含全部非银类型)高风险",
    sl_id_nbank_nsloan_bad: "通过id查询非银-持牌网络小贷中风险",
    sl_id_nbank_nsloan_overdue: "通过id查询非银-持牌网络小贷一般风险",
    sl_id_nbank_nsloan_lost: "通过id查询非银-持牌网络小贷高风险",
    sl_id_nbank_sloan_bad: "通过id查询非银-持牌小贷中风险",
    sl_id_nbank_sloan_overdue: "通过id查询非银-持牌小贷一般风险",
    sl_id_nbank_sloan_lost: "通过id查询非银-持牌小贷高风险",
    sl_id_nbank_cons_bad: "通过id查询非银-持牌消费金融中风险",
    sl_id_nbank_cons_overdue: "通过id查询非银-持牌消费金融一般风险",
    sl_id_nbank_cons_lost: "通过id查询非银-持牌消费金融高风险",
    sl_id_nbank_finlea_bad: "通过id查询非银-持牌融资租赁中风险",
    sl_id_nbank_finlea_overdue: "通过id查询非银-持牌融资租赁一般风险",
    sl_id_nbank_finlea_lost: "通过id查询非银-持牌融资租赁高风险",
    sl_id_nbank_autofin_bad: "通过id查询非银-持牌汽车金融中风险",
    sl_id_nbank_autofin_overdue: "通过id查询非银-持牌汽车金融一般风险",
    sl_id_nbank_autofin_lost: "通过id查询非银-持牌汽车金融高风险",
    sl_id_nbank_other_bad: "通过id查询非银-其他中风险",
    sl_id_nbank_other_overdue: "通过id查询非银-其他一般风险",
    sl_id_nbank_other_lost: "通过id查询非银-其他高风险",
    sl_cell_bank_bad: "通过cell查询银行(含信用卡)中风险",
    sl_cell_bank_overdue: "通过cell查询银行(含信用卡)一般风险",
    sl_cell_bank_lost: "通过cell查询银行(含信用卡)高风险",
    sl_cell_nbank_bad: "通过cell查询非银(含全部非银类型)中风险",
    sl_cell_nbank_overdue: "通过cell查询非银(含全部非银类型)一般风险",
    sl_cell_nbank_lost: "通过cell查询非银(含全部非银类型)高风险",
    sl_cell_nbank_nsloan_bad: "通过cell查询非银-持牌网络小贷中风险",
    sl_cell_nbank_nsloan_overdue: "通过cell查询非银-持牌网络小贷一般风险",
    sl_cell_nbank_nsloan_lost: "通过cell查询非银-持牌网络小贷高风险",
    sl_cell_nbank_sloan_bad: "通过cell查询非银-持牌小贷中风险",
    sl_cell_nbank_sloan_overdue: "通过cell查询非银-持牌小贷一般风险",
    sl_cell_nbank_sloan_lost: "通过cell查询非银-持牌小贷高风险",
    sl_cell_nbank_cons_bad: "通过cell查询非银-持牌消费金融中风险",
    sl_cell_nbank_cons_overdue: "通过cell查询非银-持牌消费金融一般风险",
    sl_cell_nbank_cons_lost: "通过cell查询非银-持牌消费金融高风险",
    sl_cell_nbank_finlea_bad: "通过cell查询非银-持牌融资租赁中风险",
    sl_cell_nbank_finlea_overdue: "通过cell查询非银-持牌融资租赁一般风险",
    sl_cell_nbank_finlea_lost: "通过cell查询非银-持牌融资租赁高风险",
    sl_cell_nbank_autofin_bad: "通过cell查询非银-持牌汽车金融中风险",
    sl_cell_nbank_autofin_overdue: "通过cell查询非银-持牌汽车金融一般风险",
    sl_cell_nbank_autofin_lost: "通过cell查询非银-持牌汽车金融高风险",
    sl_cell_nbank_other_bad: "通过cell查询非银-其他中风险",
    sl_cell_nbank_other_overdue: "通过cell查询非银-其他一般风险",
    sl_cell_nbank_other_lost: "通过cell查询非银-其他高风险",
    sl_id_court_bad_allnum: "通过id查询法院失信人命中次数",
    sl_id_court_executed_allnum: "通过id查询法院被执行人命中次数",
    sl_id_bank_bad_allnum: "通过id查询银行(含信用卡)中风险命中次数",
    sl_id_bank_overdue_allnum: "通过id查询银行(含信用卡)一般风险命中次数",
    sl_id_bank_lost_allnum: "通过id查询银行(含信用卡)高风险命中次数",
    sl_id_nbank_bad_allnum: "通过id查询非银(含全部非银类型)中风险命中次数",
    sl_id_nbank_overdue_allnum: "通过id查询非银(含全部非银类型)一般风险命中次数",
    sl_id_nbank_lost_allnum: "通过id查询非银(含全部非银类型)高风险命中次数",
    sl_id_nbank_nsloan_bad_allnum: "通过id查询非银-持牌网络小贷中风险命中次数",
    sl_id_nbank_nsloan_overdue_allnum: "通过id查询非银-持牌网络小贷一般风险命中次数",
    sl_id_nbank_nsloan_lost_allnum: "通过id查询非银-持牌网络小贷高风险命中次数",
    sl_id_nbank_sloan_bad_allnum: "通过id查询非银-持牌小贷中风险命中次数",
    sl_id_nbank_sloan_overdue_allnum: "通过id查询非银-持牌小贷一般风险命中次数",
    sl_id_nbank_sloan_lost_allnum: "通过id查询非银-持牌小贷高风险命中次数",
    sl_id_nbank_cons_bad_allnum: "通过id查询非银-持牌消费金融中风险命中次数",
    sl_id_nbank_cons_overdue_allnum: "通过id查询非银-持牌消费金融一般风险命中次数",
    sl_id_nbank_cons_lost_allnum: "通过id查询非银-持牌消费金融高风险命中次数",
    sl_id_nbank_finlea_bad_allnum: "通过id查询非银-持牌融资租赁中风险命中次数",
    sl_id_nbank_finlea_overdue_allnum: "通过id查询非银-持牌融资租赁一般风险命中次数",
    sl_id_nbank_finlea_lost_allnum: "通过id查询非银-持牌融资租赁高风险命中次数",
    sl_id_nbank_autofin_bad_allnum: "通过id查询非银-持牌汽车金融中风险命中次数",
    sl_id_nbank_autofin_overdue_allnum: "通过id查询非银-持牌汽车金融一般风险命中次数",
    sl_id_nbank_autofin_lost_allnum: "通过id查询非银-持牌汽车金融高风险命中次数",
    sl_id_nbank_other_bad_allnum: "通过id查询非银-其他中风险命中次数",
    sl_id_nbank_other_overdue_allnum: "通过id查询非银-其他一般风险命中次数",
    sl_id_nbank_other_lost_allnum: "通过id查询非银-其他高风险命中次数",
    sl_cell_bank_bad_allnum: "通过cell查询银行(含信用卡)中风险命中次数",
    sl_cell_bank_overdue_allnum: "通过cell查询银行(含信用卡)一般风险命中次数",
    sl_cell_bank_lost_allnum: "通过cell查询银行(含信用卡)高风险命中次数",
    sl_cell_nbank_bad_allnum: "通过cell查询非银(含全部非银类型)中风险命中次数",
    sl_cell_nbank_overdue_allnum: "通过cell查询非银(含全部非银类型)一般风险命中次数",
    sl_cell_nbank_lost_allnum: "通过cell查询非银(含全部非银类型)高风险命中次数",
    sl_cell_nbank_nsloan_bad_allnum: "通过cell查询非银-持牌网络小贷中风险命中次数",
    sl_cell_nbank_nsloan_overdue_allnum: "通过cell查询非银-持牌网络小贷一般风险命中次数",
    sl_cell_nbank_nsloan_lost_allnum: "通过cell查询非银-持牌网络小贷高风险命中次数",
    sl_cell_nbank_sloan_bad_allnum: "通过cell查询非银-持牌小贷中风险命中次数",
    sl_cell_nbank_sloan_overdue_allnum: "通过cell查询非银-持牌小贷一般风险命中次数",
    sl_cell_nbank_sloan_lost_allnum: "通过cell查询非银-持牌小贷高风险命中次数",
    sl_cell_nbank_cons_bad_allnum: "通过cell查询非银-持牌消费金融中风险命中次数",
    sl_cell_nbank_cons_overdue_allnum: "通过cell查询非银-持牌消费金融一般风险命中次数",
    sl_cell_nbank_cons_lost_allnum: "通过cell查询非银-持牌消费金融高风险命中次数",
    sl_cell_nbank_finlea_bad_allnum: "通过cell查询非银-持牌融资租赁中风险命中次数",
    sl_cell_nbank_finlea_overdue_allnum: "通过cell查询非银-持牌融资租赁一般风险命中次数",
    sl_cell_nbank_finlea_lost_allnum: "通过cell查询非银-持牌融资租赁高风险命中次数",
    sl_cell_nbank_autofin_bad_allnum: "通过cell查询非银-持牌汽车金融中风险命中次数",
    sl_cell_nbank_autofin_overdue_allnum: "通过cell查询非银-持牌汽车金融一般风险命中次数",
    sl_cell_nbank_autofin_lost_allnum: "通过cell查询非银-持牌汽车金融高风险命中次数",
    sl_cell_nbank_other_bad_allnum: "通过cell查询非银-其他中风险命中次数",
    sl_cell_nbank_other_overdue_allnum: "通过cell查询非银-其他一般风险命中次数",
    sl_cell_nbank_other_lost_allnum: "通过cell查询非银-其他高风险命中次数",
    sl_id_court_bad_time: "通过id查询法院失信人距今时间",
    sl_id_court_executed_time: "通过id查询法院被执行人距今时间",
    sl_id_bank_bad_time: "通过id查询银行(含信用卡)中风险距今时间",
    sl_id_bank_overdue_time: "通过id查询银行(含信用卡)一般风险距今时间",
    sl_id_bank_lost_time: "通过id查询银行(含信用卡)高风险距今时间",
    sl_id_nbank_bad_time: "通过id查询非银(含全部非银类型)中风险距今时间",
    sl_id_nbank_overdue_time: "通过id查询非银(含全部非银类型)一般风险距今时间",
    sl_id_nbank_lost_time: "通过id查询非银(含全部非银类型)高风险距今时间",
    sl_id_nbank_nsloan_bad_time: "通过id查询非银-持牌网络小贷中风险距今时间",
    sl_id_nbank_nsloan_overdue_time: "通过id查询非银-持牌网络小贷一般风险距今时间",
    sl_id_nbank_nsloan_lost_time: "通过id查询非银-持牌网络小贷高风险距今时间",
    sl_id_nbank_sloan_bad_time: "通过id查询非银-持牌小贷中风险距今时间",
    sl_id_nbank_sloan_overdue_time: "通过id查询非银-持牌小贷一般风险距今时间",
    sl_id_nbank_sloan_lost_time: "通过id查询非银-持牌小贷高风险距今时间",
    sl_id_nbank_cons_bad_time: "通过id查询非银-持牌消费金融中风险距今时间",
    sl_id_nbank_cons_overdue_time: "通过id查询非银-持牌消费金融一般风险距今时间",
    sl_id_nbank_cons_lost_time: "通过id查询非银-持牌消费金融高风险距今时间",
    sl_id_nbank_finlea_bad_time: "通过id查询非银-持牌融资租赁中风险距今时间",
    sl_id_nbank_finlea_overdue_time: "通过id查询非银-持牌融资租赁一般风险距今时间",
    sl_id_nbank_finlea_lost_time: "通过id查询非银-持牌融资租赁高风险距今时间",
    sl_id_nbank_autofin_bad_time: "通过id查询非银-持牌汽车金融中风险距今时间",
    sl_id_nbank_autofin_overdue_time: "通过id查询非银-持牌汽车金融一般风险距今时间",
    sl_id_nbank_autofin_lost_time: "通过id查询非银-持牌汽车金融高风险距今时间",
    sl_id_nbank_other_bad_time: "通过id查询非银-其他中风险距今时间",
    sl_id_nbank_other_overdue_time: "通过id查询非银-其他一般风险距今时间",
    sl_id_nbank_other_lost_time: "通过id查询非银-其他高风险距今时间",
    sl_cell_bank_bad_time: "通过cell查询银行(含信用卡)中风险距今时间",
    sl_cell_bank_overdue_time: "通过cell查询银行(含信用卡)一般风险距今时间",
    sl_cell_bank_lost_time: "通过cell查询银行(含信用卡)高风险距今时间",
    sl_cell_nbank_bad_time: "通过cell查询非银(含全部非银类型)中风险距今时间",
    sl_cell_nbank_overdue_time: "通过cell查询非银(含全部非银类型)一般风险距今时间",
    sl_cell_nbank_lost_time: "通过cell查询非银(含全部非银类型)高风险距今时间",
    sl_cell_nbank_nsloan_bad_time: "通过cell查询非银-持牌网络小贷中风险距今时间",
    sl_cell_nbank_nsloan_overdue_time: "通过cell查询非银-持牌网络小贷一般风险距今时间",
    sl_cell_nbank_nsloan_lost_time: "通过cell查询非银-持牌网络小贷高风险距今时间",
    sl_cell_nbank_sloan_bad_time: "通过cell查询非银-持牌小贷中风险距今时间",
    sl_cell_nbank_sloan_overdue_time: "通过cell查询非银-持牌小贷一般风险距今时间",
    sl_cell_nbank_sloan_lost_time: "通过cell查询非银-持牌小贷高风险距今时间",
    sl_cell_nbank_cons_bad_time: "通过cell查询非银-持牌消费金融中风险距今时间",
    sl_cell_nbank_cons_overdue_time: "通过cell查询非银-持牌消费金融一般风险距今时间",
    sl_cell_nbank_cons_lost_time: "通过cell查询非银-持牌消费金融高风险距今时间",
    sl_cell_nbank_finlea_bad_time: "通过cell查询非银-持牌融资租赁中风险距今时间",
    sl_cell_nbank_finlea_overdue_time: "通过cell查询非银-持牌融资租赁一般风险距今时间",
    sl_cell_nbank_finlea_lost_time: "通过cell查询非银-持牌融资租赁高风险距今时间",
    sl_cell_nbank_autofin_bad_time: "通过cell查询非银-持牌汽车金融中风险距今时间",
    sl_cell_nbank_autofin_overdue_time: "通过cell查询非银-持牌汽车金融一般风险距今时间",
    sl_cell_nbank_autofin_lost_time: "通过cell查询非银-持牌汽车金融高风险距今时间",
    sl_cell_nbank_other_bad_time: "通过cell查询非银-其他中风险距今时间",
    sl_cell_nbank_other_overdue_time: "通过cell查询非银-其他一般风险距今时间",
    sl_cell_nbank_other_lost_time: "通过cell查询非银-其他高风险距今时间",
}

export const mingName = [
    "sl_id_court_bad",
    "sl_id_court_executed",
    "sl_id_bank_bad",
    "sl_id_bank_overdue",
    "sl_id_bank_lost",
    "sl_id_nbank_bad",
    "sl_id_nbank_overdue",
    "sl_id_nbank_lost",
    "sl_id_nbank_nsloan_bad",
    "sl_id_nbank_nsloan_overdue",
    "sl_id_nbank_nsloan_lost",
    "sl_id_nbank_sloan_bad",
    "sl_id_nbank_sloan_overdue",
    "sl_id_nbank_sloan_lost",
    "sl_id_nbank_cons_bad",
    "sl_id_nbank_cons_overdue",
    "sl_id_nbank_cons_lost",
    "sl_id_nbank_finlea_bad",
    "sl_id_nbank_finlea_overdue",
    "sl_id_nbank_finlea_lost",
    "sl_id_nbank_autofin_bad",
    "sl_id_nbank_autofin_overdue",
    "sl_id_nbank_autofin_lost",
    "sl_id_nbank_other_bad",
    "sl_id_nbank_other_overdue",
    "sl_id_nbank_other_lost",
    "sl_cell_bank_bad",
    "sl_cell_bank_overdue",
    "sl_cell_bank_lost",
    "sl_cell_nbank_bad",
    "sl_cell_nbank_overdue",
    "sl_cell_nbank_lost",
    "sl_cell_nbank_nsloan_bad",
    "sl_cell_nbank_nsloan_overdue",
    "sl_cell_nbank_nsloan_lost",
    "sl_cell_nbank_sloan_bad",
    "sl_cell_nbank_sloan_overdue",
    "sl_cell_nbank_sloan_lost",
    "sl_cell_nbank_cons_bad",
    "sl_cell_nbank_cons_overdue",
    "sl_cell_nbank_cons_lost",
    "sl_cell_nbank_finlea_bad",
    "sl_cell_nbank_finlea_overdue",
    "sl_cell_nbank_finlea_lost",
    "sl_cell_nbank_autofin_bad",
    "sl_cell_nbank_autofin_overdue",
    "sl_cell_nbank_autofin_lost",
    "sl_cell_nbank_other_bad",
    "sl_cell_nbank_other_overdue",
    "sl_cell_nbank_other_lost"
  ];
  
export const ciName = [
    "sl_id_court_bad_allnum",
    "sl_id_court_executed_allnum",
    "sl_id_bank_bad_allnum",
    "sl_id_bank_overdue_allnum",
    "sl_id_bank_lost_allnum",
    "sl_id_nbank_bad_allnum",
    "sl_id_nbank_overdue_allnum",
    "sl_id_nbank_lost_allnum",
    "sl_id_nbank_nsloan_bad_allnum",
    "sl_id_nbank_nsloan_overdue_allnum",
    "sl_id_nbank_nsloan_lost_allnum",
    "sl_id_nbank_sloan_bad_allnum",
    "sl_id_nbank_sloan_overdue_allnum",
    "sl_id_nbank_sloan_lost_allnum",
    "sl_id_nbank_cons_bad_allnum",
    "sl_id_nbank_cons_overdue_allnum",
    "sl_id_nbank_cons_lost_allnum",
    "sl_id_nbank_finlea_bad_allnum",
    "sl_id_nbank_finlea_overdue_allnum",
    "sl_id_nbank_finlea_lost_allnum",
    "sl_id_nbank_autofin_bad_allnum",
    "sl_id_nbank_autofin_overdue_allnum",
    "sl_id_nbank_autofin_lost_allnum",
    "sl_id_nbank_other_bad_allnum",
    "sl_id_nbank_other_overdue_allnum",
    "sl_id_nbank_other_lost_allnum",
    "sl_cell_bank_bad_allnum",
    "sl_cell_bank_overdue_allnum",
    "sl_cell_bank_lost_allnum",
    "sl_cell_nbank_bad_allnum",
    "sl_cell_nbank_overdue_allnum",
    "sl_cell_nbank_lost_allnum",
    "sl_cell_nbank_nsloan_bad_allnum",
    "sl_cell_nbank_nsloan_overdue_allnum",
    "sl_cell_nbank_nsloan_lost_allnum",
    "sl_cell_nbank_sloan_bad_allnum",
    "sl_cell_nbank_sloan_overdue_allnum",
    "sl_cell_nbank_sloan_lost_allnum",
    "sl_cell_nbank_cons_bad_allnum",
    "sl_cell_nbank_cons_overdue_allnum",
    "sl_cell_nbank_cons_lost_allnum",
    "sl_cell_nbank_finlea_bad_allnum",
    "sl_cell_nbank_finlea_overdue_allnum",
    "sl_cell_nbank_finlea_lost_allnum",
    "sl_cell_nbank_autofin_bad_allnum",
    "sl_cell_nbank_autofin_overdue_allnum",
    "sl_cell_nbank_autofin_lost_allnum",
    "sl_cell_nbank_other_bad_allnum",
    "sl_cell_nbank_other_overdue_allnum",
    "sl_cell_nbank_other_lost_allnum"
  ];
  

  export const nianName = [
    "sl_id_court_bad_time",
    "sl_id_court_executed_time",
    "sl_id_bank_bad_time",
    "sl_id_bank_overdue_time",
    "sl_id_bank_lost_time",
    "sl_id_nbank_bad_time",
    "sl_id_nbank_overdue_time",
    "sl_id_nbank_lost_time",
    "sl_id_nbank_nsloan_bad_time",
    "sl_id_nbank_nsloan_overdue_time",
    "sl_id_nbank_nsloan_lost_time",
    "sl_id_nbank_sloan_bad_time",
    "sl_id_nbank_sloan_overdue_time",
    "sl_id_nbank_sloan_lost_time",
    "sl_id_nbank_cons_bad_time",
    "sl_id_nbank_cons_overdue_time",
    "sl_id_nbank_cons_lost_time",
    "sl_id_nbank_finlea_bad_time",
    "sl_id_nbank_finlea_overdue_time",
    "sl_id_nbank_finlea_lost_time",
    "sl_id_nbank_autofin_bad_time",
    "sl_id_nbank_autofin_overdue_time",
    "sl_id_nbank_autofin_lost_time",
    "sl_id_nbank_other_bad_time",
    "sl_id_nbank_other_overdue_time",
    "sl_id_nbank_other_lost_time",
    "sl_cell_bank_bad_time",
    "sl_cell_bank_overdue_time",
    "sl_cell_bank_lost_time",
    "sl_cell_nbank_bad_time",
    "sl_cell_nbank_overdue_time",
    "sl_cell_nbank_lost_time",
    "sl_cell_nbank_nsloan_bad_time",
    "sl_cell_nbank_nsloan_overdue_time",
    "sl_cell_nbank_nsloan_lost_time",
    "sl_cell_nbank_sloan_bad_time",
    "sl_cell_nbank_sloan_overdue_time",
    "sl_cell_nbank_sloan_lost_time",
    "sl_cell_nbank_cons_bad_time",
    "sl_cell_nbank_cons_overdue_time",
    "sl_cell_nbank_cons_lost_time",
    "sl_cell_nbank_finlea_bad_time",
    "sl_cell_nbank_finlea_overdue_time",
    "sl_cell_nbank_finlea_lost_time",
    "sl_cell_nbank_autofin_bad_time",
    "sl_cell_nbank_autofin_overdue_time",
    "sl_cell_nbank_autofin_lost_time",
    "sl_cell_nbank_other_bad_time",
    "sl_cell_nbank_other_overdue_time",
    "sl_cell_nbank_other_lost_time"
  ];
  